export const initialState = {
  auth: {
    user: null,
  },
  locations: {
    data: null,
  },
}
